import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="app-footer">
      <div className="app-footer__inner">
        <div className="app-footer__brand">
          <img src="/images/logo-mark.svg" alt="" width={28} height={28} />
          <div>
            <strong>DreamGraph</strong>
            <p>Persistent architectural memory for AI agents.</p>
          </div>
        </div>
        <div className="app-footer__cols">
          <div>
            <h4>Product</h4>
            <Link to="/features">Features</Link>
            <Link to="/download">Download</Link>
            <Link to="/sponsor">Sponsor</Link>
          </div>
          <div>
            <h4>Documentation</h4>
            <Link to="/guide/overview">User Guide</Link>
            <Link to="/guide/installation">Installation</Link>
            <Link to="/guide/troubleshooting-faq">Troubleshooting</Link>
          </div>
          <div>
            <h4>Project</h4>
            <a href="https://github.com/mmethodz/dreamgraph" target="_blank" rel="noreferrer">GitHub</a>
            <a href="https://github.com/sponsors/mmethodz" target="_blank" rel="noreferrer">GitHub Sponsors</a>
            <a href="https://github.com/mmethodz/dreamgraph/issues" target="_blank" rel="noreferrer">Report an issue</a>
          </div>
        </div>
      </div>
      <div className="app-footer__legal">
        <span>© {new Date().getFullYear()} DreamGraph · Source-available license</span>
        <span>dreamgraph.nofs.ai</span>
      </div>
    </footer>
  );
}
